<script setup lang="ts">
/**
 * Alexia Shop - Root App Component
 * ==================================
 * Main application wrapper with layout components.
 */

import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useCookieStore } from '@/stores/cookies'
import { useCartStore } from '@/stores/cart'

import TheNavbar from '@/components/layout/TheNavbar.vue'
import TheFooter from '@/components/layout/TheFooter.vue'
import CookieBanner from '@/components/cookies/CookieBanner.vue'
import CookieSettingsModal from '@/components/cookies/CookieSettingsModal.vue'
import MiniCart from '@/components/cart/MiniCart.vue'

const authStore = useAuthStore()
const cookieStore = useCookieStore()
const cartStore = useCartStore()

onMounted(() => {
  // Load cookie preferences (sync, no API)
  cookieStore.loadPreferences()

  // Check auth and fetch cart in background (don't block UI)
  authStore.checkAuth().catch(() => {})
  cartStore.fetchCart().catch(() => {})
})
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <!-- Navigation -->
    <TheNavbar />

    <!-- Main Content -->
    <main class="flex-grow">
      <RouterView v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </RouterView>
    </main>

    <!-- Footer -->
    <TheFooter />

    <!-- Cookie Consent Banner -->
    <CookieBanner />

    <!-- Cookie Settings Modal -->
    <CookieSettingsModal />

    <!-- Mini Cart Drawer -->
    <MiniCart />
  </div>
</template>

<style>
/* Page transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
